import { Children, Component } from 'react';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
const childrenToArray = children => {
  const result = [];
  Children.forEach(children, child => {
    result.push(child);
  });
  return result;
};
const listOptions = {
  excessKey: true,
  exclusive: true,
  lastWordConnector: true,
  limit: true,
  locale: true,
  twoWordsConnector: true,
  wordsConnector: true
};
export default class FormattedList extends Component {
  constructor(...args) {
    super(...args);
    this.getPassThroughProps = () => {
      const passThrough = {};
      Object.keys(this.props).forEach(key => {
        // @ts-expect-error dynamic key access
        if (!listOptions[key]) {
          // @ts-expect-error dynamic key access
          passThrough[key] = this.props[key];
        }
      });
      return passThrough;
    };
  }
  render() {
    return /*#__PURE__*/_jsx("span", Object.assign({}, this.getPassThroughProps(), {
      children: I18n.formatListArray(childrenToArray(this.props.children), this.props)
    }));
  }
}
FormattedList.displayName = 'FormattedList';
FormattedList.contextType = I18nHMRContext;